import { message } from "antd"
import { Service } from "../service"

/**
 * Obtiene la lista de farmacias desde el servicio
 * @returns {Promise<Array>} - Lista de farmacias o array vacío en caso de error
 */
export const fetchPharmacies = async () => {
    try {
        const service = new Service()
        const pharmacies = await service.getPharmacies()
        return pharmacies || []
    } catch (error) {
        message.error("Error al obtener farmacias")
        console.error(error)
        return []
    }
}
